type VideoLabellingEventNamesT = {
  VIDEO_PLAYER_CONTROLS: 'video_player_controls';
  VIDEO_FRAME_SELECT: 'video_frame_select';
  VIDEO_FRAME_NUMBER_INPUT: 'video_frame_number_input';
  ANNOTATION_TIMELINE_SELECTION: 'annotation_timeline_selection';
  ANNOTATION_INTERPOLATE_SAVE: 'annotation_interpolate_save';
  ANNOTATION_INTERPOLATE_DELETE: 'annotation_interpolate_delete';
  VIDEO_SAM_TRACK: 'video_sam_track';
  CHANGE_VIDEO: 'change_video';
  VIDEO_LABELING_LOAD: 'video_labeling_load';
};
export const VIDEO_LABELLING_EVENT_NAMES: VideoLabellingEventNamesT = Object.freeze({
  VIDEO_PLAYER_CONTROLS: 'video_player_controls',
  VIDEO_FRAME_SELECT: 'video_frame_select',
  VIDEO_FRAME_NUMBER_INPUT: 'video_frame_number_input',
  ANNOTATION_TIMELINE_SELECTION: 'annotation_timeline_selection',
  ANNOTATION_INTERPOLATE_SAVE: 'annotation_interpolate_save',
  ANNOTATION_INTERPOLATE_DELETE: 'annotation_interpolate_delete',
  VIDEO_SAM_TRACK: 'video_sam_track',
  CHANGE_VIDEO: 'change_video',
  VIDEO_LABELING_LOAD: 'video_labeling_load'
});